import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    List,
    ListItem,
    ListItemText,
    Stack,
    ListItemIcon,
} from '@mui/material';
import {Trip, Visit} from './Trip';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';

interface TripModalProps {
    open: boolean;
    onClose: () => void;
    trip: Trip | null;
}

const TripModal: React.FC<TripModalProps> = ({open, onClose, trip}) => {
    if (!trip) return null;

    const handlePrint = () => {
        const printContent = document.querySelector('.MuiDialogContent-root');
        if (!printContent) return;

        const printWindow = window.open('', '_blank');
        if (!printWindow) return;

        const styles = Array.from(document.styleSheets)
            .map(styleSheet => {
                try {
                    return Array.from(styleSheet.cssRules)
                        .map(rule => rule.cssText)
                        .join('\n');
                } catch (e) {
                    return '';
                }
            })
            .join('\n');

        printWindow.document.write(`
            <html lang="ro">
                <head>
                    <title>Aventură & Călătorii excursie ${trip.name}</title>
                    <style>
                        ${styles}
                        @page { margin: 0; }
                        @media print {
                            body { 
                            margin: 40px; 
                            color: rgba(0, 0, 0, 0.87) !important;
                            }
                            * {
                            color: rgba(0, 0, 0, 0.87) !important;
                        }
                        }
                    </style>
                </head>
                <body>
                <h1>${trip.name}</h1>
                    ${printContent.innerHTML}
                </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.print();
        printWindow.close();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle color="primary.contrastText">{trip.name}</DialogTitle>
            <DialogContent dividers>
                <Stack direction="row" alignItems="center" padding="10px 20px" gap="10px">
                    <SyncAltIcon sx={{color: 'primary.contrastText'}}/>
                    <Typography variant="subtitle1">
                        {trip.route}
                    </Typography>
                </Stack>


                {trip.notes && <Stack padding="20px">
                    <Typography variant="body2">{trip.notes}  </Typography>
                </Stack>}

                {trip.days.map((day: Array<Visit>, index: number) => (
                    <div key={index} style={{marginTop: 8}}>
                        {/*show day name only for multi-days trips*/}
                        {trip.days.length > 1 && <Typography variant="subtitle2">Ziua {index + 1}</Typography>}

                        <List>
                            {day.map((visit, idx) => (
                                <ListItem key={idx}>
                                    <ListItemIcon><TaskAltIcon sx={{color: 'primary.contrastText'}}/></ListItemIcon>
                                    <ListItemText
                                        primary={visit.locationName}
                                        secondary={visit.details}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </div>
                ))}

                <Typography variant="body2" padding="20px">
                    <InfoOutlineIcon sx={{color: 'primary.contrastText', height: '18px'}}/>
                    Ordinea exactă a obiectivelor turistice se va stabili în momentul întocmirii programului excursiei
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handlePrint} color="primary">
                    Printează
                </Button>
                <Button onClick={onClose} sx={{color: "primary.contrastText"}}>
                    Închide
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TripModal;
